/*
| Toast + accessibility live region (PRD 6.4). One visual pill at a time, dark,
| auto-dismissing; every message is also mirrored to a persistent aria-live
| region so nothing is silent for screen readers.
*/
let live: HTMLElement | null = null;
let pill: HTMLElement | null = null;
let hideTimer: number | undefined;
let hidePillTimer: number | undefined;

const ensureNodes = (): void => {
    if (live && pill) return;

    live = document.createElement('div');
    live.setAttribute('aria-live', 'polite');
    live.className = 'sr-only';
    live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';

    pill = document.createElement('div');
    pill.setAttribute('role', 'status');
    pill.className = 'th-toast';
    pill.hidden = true;

    document.body.append(live, pill);
};

export function toast(message: string): void {
    ensureNodes();
    live!.textContent = message;
    pill!.textContent = message;
    pill!.hidden = false;
    // Next frame so the entrance transition runs from the hidden state.
    requestAnimationFrame(() => pill!.classList.add('th-toast--in'));

    window.clearTimeout(hideTimer);
    window.clearTimeout(hidePillTimer);
    hideTimer = window.setTimeout(() => {
        pill!.classList.remove('th-toast--in');
        hidePillTimer = window.setTimeout(() => { pill!.hidden = true; }, 500);
    }, 2600);
}
